import {
	BlurModal, ModalHeader,
} from '@aleph/shared-components';
import UpdateAdAccount from 'wb-spotify/app/routes/superGrid/mutator/adAccount/updateAdAccount';

const AdAccountMutator = ({ title, onClose }: { title: string, onClose: () => void }) => (
	<BlurModal
		header={
			<ModalHeader onClose={onClose}
				title={title}
			/>
		}
		onClose={onClose}
	>
		<div className="flex flex-1 grow flex-col px-6">
			<UpdateAdAccount />
		</div>
	</BlurModal>
);

export default AdAccountMutator;
